import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'disableDuwButton'
})
export class DisableDuwButtonPipe implements PipeTransform {

  transform(data: any): boolean {
    const {
      disableDuw,
      hasInvalidQuote,
      selectSubmissionUWRsIsLoading,
      selectPolicyUWRsIsLoading,
      selectUWApprovalIsLoading
    } = data;

    return disableDuw ||
      hasInvalidQuote ||
      selectSubmissionUWRsIsLoading ||
      selectPolicyUWRsIsLoading ||
      selectUWApprovalIsLoading;
  }
}
